import { Entry } from '../Entry'

export function Entry20220727() {
  return (
    <Entry title="27/07/2022 - v3.1.2">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/12677/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
